export function buildImageSource(
    images?: string | Inspire.Image[],
    namespace: string = '',
    imageSize?: { width: number; height: number },
): string | undefined {
    if (!images || typeof images === 'string') {
        return images;
    }

    const filteredImages = images.filter((image) => image.url.includes(namespace));

    if (imageSize) {
        // ближайшее по размеру изображение
        const closestImage = filteredImages.reduce((prev, curr) =>
            Math.abs(curr.height - imageSize.height) < Math.abs(prev.height - imageSize.height)
                ? curr
                : prev,
        );

        // ближайшее по размеру, но не меньше imageSize
        const closestButMoreImage = filteredImages.reduce((prev, curr) =>
            Math.abs(curr.height - imageSize.height) < Math.abs(prev.height - imageSize.height) &&
            curr.height >= imageSize.height &&
            curr.width >= imageSize.width
                ? curr
                : prev,
        );

        return closestButMoreImage?.url ?? closestImage?.url;
    }

    const [largestImage] = (filteredImages.length > 0 ? filteredImages : images).sort(
        (left, right) => right.width - left.width,
    );

    return largestImage?.url;
}

export function buildImageSourceSet(
    images?: string | Inspire.Image[],
    namespace: string = '',
    imageSize?: { width: number; height: number },
): string | undefined {
    if (!images || typeof images === 'string') {
        return undefined;
    }

    if (imageSize) {
        return undefined;
    }

    return images
        .filter((image) => image.url.includes(namespace))
        .sort((left, right) => left.width - right.width)
        .map((image) => `${image.url} ${image.width}w`)
        .join(', ');
}
